import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ClientConnectSidebarComponent } from './features/client-connect-sidebar/client-connect-sidebar.component';
import { MessageNotificationsComponent } from './shared/components/message-notifications/message-notifications.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ClientConnectSidebarComponent, MessageNotificationsComponent],
  template: `
    <router-outlet />
    <app-client-connect-sidebar />
    <app-message-notifications />
  `,
  styles: [
    `
      :host {
        display: block;
        min-height: 100vh;
      }
    `,
  ],
})
export class AppComponent {}

